// extracted by mini-css-extract-plugin
module.exports = {"button":"open-button_button__OWVqb","icon":"open-button_icon__2iNvM","iconOpen":"open-button_iconOpen__CpXpH"};